
function MouseParallax() {

    $('.mouse-parallax').each( function(){

        let container = $(this);
        let containerBackground = $('.mouse-parallax__bg', container);
        let containerText = $('.mouse-parallax__txt', container);

        container.on('mousemove', function (event) {
            if( containerBackground.length > 0 ) {
                gsap.to(containerBackground, 1, {
                    x: (event.pageX - container.width() / 10) / container.width() * 10,
                    // y: (event.pageY - container.height() / 10) / container.height() * 10
                });
            }
            if( containerText.length > 0 ) {
                let relX = event.pageX - container.offset().left;
                let relY = event.pageY - container.offset().top;
                gsap.to(containerText, 1, {
                    x: (relX - container.width() / 10) / container.width() * 20,
                    // y: (relY - container.height() / 10) / container.height() * 20
                });
            }
        }.bind(this)).on('mouseleave', function () {
            if( containerBackground.length > 0 ) {
                gsap.to(containerBackground, 1, {x: 0, y: 0});
            }
            if( containerText.length > 0 ) {
                gsap.to(containerText, 1, {x: 0, y: 0});
            }
        }.bind(this));

    });

    this.footer = $('.footer');
    this.footerBackground = $('.footer-bg__img');

    if(this.footerBackground.length){
        $('.page-container').on('mousemove', function (event) {
            let relX = event.pageX - this.footer.offset().left;
            let relY = event.pageY - this.footer.offset().top;
            gsap.to(this.footerBackground, 1, {
                x: (relX - this.footer.width() / 10) / this.footer.width() * 10,
                // y: (relY - this.footer.height() / 10) / this.footer.height() * 10
            });
        }.bind(this)).on('mouseleave', function () {
            gsap.to(this.footerBackground, 1, {x: 0, y: 0});
        }.bind(this));
    }
}
